<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="12">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder=" $l('form_label_search_left') || '属性类型/属性名称/属性名英文搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                $emit('openEditFormDialog', {
                  type: 'add',
                })
              "
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>{{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}

export default {
  data() {
    return {
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
  },
}
</script>